"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitState = void 0;
const Store_1 = require("./Store");
const Bus = require("./Bus");
const lodash_1 = require("lodash");
const operations_1 = require("./ducks/config/operations");
async function InitState() {
    let currentUserId;
    let currentConfig;
    Store_1.store.subscribe(() => {
        const state = Store_1.store.getState();
        const newUserId = lodash_1.get(state, 'me.user.id');
        if (newUserId && newUserId !== currentUserId) {
            currentUserId = newUserId;
            Bus.trigger(Bus.ON_USER_READY, { userId: currentUserId });
        }
        else if (currentUserId && newUserId !== currentUserId) {
            Bus.trigger(Bus.ON_USER_LOGOUT);
        }
        const newConfig = lodash_1.get(state, 'config.config');
        if (newConfig && newConfig !== currentConfig) {
            currentConfig = newConfig;
            Bus.trigger(Bus.ON_CONFIG_READY, currentConfig);
        }
    });
    return operations_1.fetch(Store_1.store.dispatch)();
}
exports.InitState = InitState;
//# sourceMappingURL=Init.js.map